import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/ScrollReveal";
import { useLanguage } from "@/contexts/LanguageContext";

export function CaseTeaserSection() {
  const { language, localizedPath } = useLanguage();
  const isDe = language === "de";

  const headline = isDe
    ? "Deutschlands erstes Micro Drama kam von uns."
    : "Germany's first Micro Drama came from us.";

  const text = isDe
    ? "AMINHO — THE CHALLENGE, entwickelt von reelistiq mit Skechers und Constantin Creators. Featured in Campaign Germany und Business Punk."
    : "AMINHO — THE CHALLENGE, developed by reelistiq with Skechers and Constantin Creators. Featured in Campaign Germany and Business Punk.";

  const metrics = isDe
    ? [
        { value: "1,1 Mio.", label: "Views" },
        { value: "Ø 55.000", label: "Views pro Episode" },
        { value: "+218 %", label: "Views Episode 1 bis Finale" },
      ]
    : [
        { value: "1.1M", label: "Views" },
        { value: "Ø 55K", label: "Views per episode" },
        { value: "+218%", label: "Views episode 1 to finale" },
      ];

  return (
    <section className="py-32 md:py-40 px-6">
      <div className="max-w-[1400px] mx-auto">
        <ScrollReveal>
          <p className="text-label mb-8">CASE 001</p>
        </ScrollReveal>

        <ScrollReveal delay={100}>
          <h3 className="font-display text-3xl md:text-5xl font-bold tracking-tight max-w-3xl">
            {headline}
          </h3>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <p className="mt-6 text-body-md text-muted-foreground max-w-2xl leading-relaxed">
            {text}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={300}>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            {metrics.map((m) => (
              <div key={m.label}>
                <p className="font-display text-4xl md:text-5xl font-bold tracking-tight">
                  {m.value}
                </p>
                <p className="mt-3 text-xs uppercase tracking-widest text-muted-foreground">
                  {m.label}
                </p>
              </div>
            ))}
          </div>
        </ScrollReveal>

        <ScrollReveal delay={400}>
          <Link
            to={localizedPath("/work")}
            className="inline-flex items-center mt-16 px-10 py-4 rounded-full bg-accent text-accent-foreground text-sm font-medium uppercase tracking-wider hover:opacity-90 transition-opacity"
          >
            {isDe ? "ZUM CASE" : "VIEW CASE"} →
          </Link>
        </ScrollReveal>
      </div>
    </section>
  );
}
